import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { CBLogoV2 } from '../../lib/components/Icon'
import { clearPartnerSession, getPartnerSession } from '../../lib/utils/partner-session'
import { partnerServices } from '../../services'
import { formatPartnerStatus, partnerStatusClass } from './partner-format'

import './partner.scss'

export const PartnerStatus = ({ status }: { status?: string | null }) => (
  <span className={`partner-status ${partnerStatusClass(status)}`}>
    {formatPartnerStatus(status)}
  </span>
)

export const PartnerShell = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate()
  const session = getPartnerSession()
  const [isLoggingOut, setIsLoggingOut] = useState(false)

  const handleLogout = async () => {
    setIsLoggingOut(true)
    try {
      await partnerServices.logout()
    } catch {
      // A 401 already sends the browser back to login.
    }
    clearPartnerSession()
    navigate('/partner', { replace: true })
  }

  return (
    <div className='partner-portal' data-testid='partner-portal'>
      <header className='partner-portal__header'>
        <Link to='/partner/investors' className='partner-portal__brand' aria-label='Investor book'>
          <CBLogoV2 classes={['partner-portal__logo']} width='148' height='36' />
        </Link>
        <div className='partner-portal__header-actions'>
          {session?.name ? (
            <span className='partner-portal__partner-name'>{session.name}</span>
          ) : null}
          <button
            type='button'
            className='partner-portal__logout'
            onClick={handleLogout}
            disabled={isLoggingOut}
          >
            {isLoggingOut ? 'Logging out...' : 'Log out'}
          </button>
        </div>
      </header>
      <main className='partner-portal__main'>{children}</main>
    </div>
  )
}
